"use client";

import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ArchitectsOfLegalSovereignty() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const marqueeItems = ["TRUST STRUCTURES", "ESTATE PLANNING", "ASSET PROTECTION", "SOVEREIGN COUNSEL", "JURISDICTIONAL ANALYSIS", "TRUST STRUCTURES", "ESTATE PLANNING", "ASSET PROTECTION", "SOVEREIGN COUNSEL", "JURISDICTIONAL ANALYSIS"];
  return <section data-section-id="2992" id="architects-of-legal-sovereignty" className="dark bg-background text-foreground min-h-screen w-full overflow-hidden flex flex-col">
      {}
      <div className="hidden md:block absolute top-1/2 left-6 z-20 -translate-y-1/2 origin-center">
        <div className="font-mono text-xs uppercase tracking-[0.3em] text-muted-foreground whitespace-nowrap" style={{
        transform: "rotate(-90deg)"
      }}>
          EST. 2024 / VESTA
        </div>
      </div>

      {}
      <div className="flex-1 grid grid-cols-1 lg:grid-cols-12 w-full pt-24 lg:pt-20">
        {}
        <div ref={leftRef} className="lg:col-span-7 flex flex-col justify-center px-6 md:px-12 lg:pl-24 lg:pr-12 py-12 lg:py-0 order-2 lg:order-1">
          <div className={`transition-all duration-1000 ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            {}
            <div className="font-mono text-xs uppercase tracking-[0.25em] text-muted-foreground mb-8 flex items-center gap-3">
              <span className="inline-block w-8 h-px bg-primary" />
              MARYLAND LEGAL COUNSEL
            </div>

            {}
            <h1 className="font-default font-bold text-foreground leading-[0.85] tracking-[-0.04em] uppercase" style={{
            fontSize: "clamp(4rem, 14vw, 13rem)"
          }}>
              <span className="block">LEGAL</span>
              <span className="block">
                AUTON<span className="text-primary">O</span>MY
              </span>
            </h1>

            {}
            <div className="mt-10 mb-8">
              <div className="w-20 h-px bg-primary mb-6" />
              <p className="font-default text-lg md:text-xl text-muted-foreground leading-relaxed max-w-xl">
                Expert guidance in trust law and sovereign citizenship. Designing secure financial legacies through meticulous legal analysis.
              </p>
            </div>

            {}
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-6 mt-10">
              <Link to="/TrustsEstatesPage" className="group inline-block">
                <Button className="bg-primary text-primary-foreground hover:bg-primary uppercase font-default font-bold tracking-wider text-sm px-8 py-7 border-0 transition-all duration-300" style={{
                boxShadow: "12px 12px 0px 0px hsl(25 60% 55% / 0.2)"
              }} onMouseEnter={e => {
                (e.currentTarget as HTMLButtonElement).style.boxShadow = "4px 4px 0px 0px hsl(25 60% 55% / 0.2)";
                (e.currentTarget as HTMLButtonElement).style.transform = "translate(8px, 8px)";
              }} onMouseLeave={e => {
                (e.currentTarget as HTMLButtonElement).style.boxShadow = "12px 12px 0px 0px hsl(25 60% 55% / 0.2)";
                (e.currentTarget as HTMLButtonElement).style.transform = "translate(0, 0)";
              }}>
                  EXPLORE OUR SERVICES
                  <ArrowRight className="ml-2 size-4" />
                </Button>
              </Link>

              <Link to="/ContactPage" className="group relative font-default uppercase tracking-wider text-sm font-medium text-foreground inline-block py-2">
                <span className="relative z-10">SCHEDULE A CONSULTATION</span>
                <span className="absolute bottom-0 left-0 w-0 h-px bg-primary transition-all duration-500 group-hover:w-full" />
              </Link>
            </div>
          </div>
        </div>

        {}
        <div ref={rightRef} className={`lg:col-span-5 relative min-h-[50vh] lg:min-h-full order-1 lg:order-2 transition-all duration-1000 ${rightVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699670/img/vesta_legal_architecture.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699670/img/vesta_legal_architecture.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1699670/img/vesta_legal_architecture.png-wvc-sizes" alt="Stately Maryland architecture representing legal authority" loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover" />

          {}
          <div className="absolute inset-0 bg-gradient-to-tr from-background/40 via-transparent to-transparent pointer-events-none" />

          {}
          <div className="absolute bottom-6 right-6 md:bottom-10 md:right-10 max-w-xs p-6 backdrop-blur-xl border border-foreground/20" style={{
          backgroundColor: "hsl(220 20% 4% / 0.6)"
        }}>
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-primary mb-3">
              PRACTICE AREA
            </div>
            <div className="font-default text-xl text-foreground leading-tight">
              Sovereign Counsel
              <span className="block text-muted-foreground italic mt-1">— Jurisdictional Strategy</span>
            </div>
            <div className="mt-4 pt-4 border-t border-foreground/15 flex items-center justify-between">
              <span className="font-mono text-[10px] uppercase tracking-wider text-muted-foreground">
                VESTA // 2025
              </span>
              <span className="w-2 h-2 bg-primary inline-block" />
            </div>
          </div>

          {}
          <div className="absolute top-6 right-6 hidden md:flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.3em] text-foreground/70">
            <span className="w-6 h-px bg-foreground/50" />
            MARYLAND
          </div>
        </div>
      </div>

      {}
      <div className="relative w-full border-t border-border/40 overflow-hidden py-6 bg-background">
        <div className="flex whitespace-nowrap animate-[wild-marquee_40s_linear_infinite]">
          {[...marqueeItems, ...marqueeItems].map((item, i) => <div data-index={i} key={i} className="flex items-center font-default uppercase tracking-[0.2em] text-sm md:text-base text-muted-foreground/60 px-8">
              <span>{item}</span>
              <span className="ml-8 w-1.5 h-1.5 bg-primary inline-block" />
            </div>)}
        </div>
      </div>

      <style>{`
        @keyframes wild-marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </section>;
}